import React from "react";
import ReportWebex from "./ReportWebex";
import Loader from "../../../../components/Loader";

export default function StatisticsReportWebex({ data, people }) {
    return (
        data ? (
            <ReportWebex data={data} people={people}/>  
        ) : (
            <Loader/>
        )
    );
}